import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './BackButton.css';

interface BackButtonProps {
  to: string;
}

/**
 * BackButton component - displays a back button that navigates to the specified route
 */
const BackButton: React.FC<BackButtonProps> = ({ to }) => {
  const { t } = useTranslation('common');
  return (
    <Link to={to} className="back-button-link">
      <div className="back-button">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span>{t('back')}</span>
      </div>
    </Link>
  );
};

export default BackButton;
